import { gql } from 'apollo-angular';

export const CheckTacticStatusDocument = gql/* GraphQL*/ `
  query checkTacticStatus($id: Int!) {
    getTactic(id: $id) {
      verificationStatus
    }
  }
`;
